import axios from 'axios';
import config from '../config';

/**
 * Guest endpoints use HttpOnly cookies; no JWT interceptor (avoids conflating 401 with main auth refresh).
 */
const guestApi = axios.create({
  baseURL: config.apiBaseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default guestApi;
